export const noop = () => {}; // eslint-disable-line @typescript-eslint/no-empty-function
